import React from "react";
import Animated from "react-native-reanimated";
import { style } from "./Header.style";
const Header = ({ children, sticky = true, style: customStyle }) => (React.createElement(Animated.View, { style: [style.header, sticky && style.stickyHeader, customStyle] }, children));
export { Header };
